import Vue from 'vue';
import {
	Carousel,
	CarouselItem,
	Dropdown,
	DropdownMenu,
	DropdownItem,
	Drawer,
	Menu,
	Submenu,
	Pagination,
	Collapse,
	Input,
	Form,
	FormItem,
	CollapseItem,
  Message,
  InputNumber,
  Loading,
  Dialog,
  Image
} from 'element-ui';

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Drawer)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(Pagination)
Vue.use(Collapse)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(CollapseItem)
Vue.use(InputNumber)
Vue.use(Loading.directive)
Vue.use(Dialog)
Vue.use(Image)


Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;



// WEBPACK FOOTER //
// ./src/assets/element_ui.js